import { Card, CardBody, Col } from "reactstrap";
import { P } from "../../../AbstractElements";
import { TextColorTitle } from "../../../Constants/Constants";
import { TextColorData, TextColorSubTitle } from "../../../Data/UiKits/Typography";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const TextColor = () => {
  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={TextColorTitle} span={TextColorSubTitle} />
        <CardBody>
          <div className="d-flex flex-column gap-2">
            {TextColorData &&
              TextColorData.map((item, index) => (
                <P key={index} className={`mb-0 txt-${item.class}`}>
                  {item.text} <code>{`.txt-${item.class}`}</code> {"class"}
                </P>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default TextColor;
